<template>
  <CustomDeleteDialog
    dialogTitle="کنسل کردن کلاس گروهی"
    dialogId="cancel-termic-course-confirmation-dialog"
    okTitle="بله"
    cancelTitle="خیر"
    :isOkDisabled="isLoading"
    @ok="cancelTermicCourseByAdmin"
  >
    <BCol cols="12">
      <p>
        آیا از کنسل کردن کلاس ترمیک
        <span style="font-weight: bold">{{
          termicCourseDetails && termicCourseDetails.termicCourseName
            ? termicCourseDetails.termicCourseName
            : ""
        }}</span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    termicCourseDetails: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async cancelTermicCourseByAdmin() {
      try {
        this.isLoading = true;
        const _this = this;
        const cancelTermicCourse = new CancelTermicCourse(_this);
        cancelTermicCourse.setRequestParam({
          termicCourseId: this.termicCourseDetails.id,
        });
        await cancelTermicCourse.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کنسل شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس ترمیک با موفقیت کنسل شد.",
              },
            });
            this.$bvModal.hide("cancel-termic-course-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کنسل نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { CancelTermicCourse } from "@/libs/Api/TermicCourses";
import { BCol } from "bootstrap-vue";
</script>
